import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    if (window.location.pathname.includes('business-portal')) {
      try {
        const registration = await navigator.serviceWorker.getRegistration('/ngsw-worker.js');
        if (!registration) {
          await navigator.serviceWorker.register('/ngsw-worker.js');
        }
      } catch (error) {
        console.error('Service Worker registration failed:', error);
      }
    }
  });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  // eslint-disable-next-line no-console
  .catch((err) => console.error(err));
